import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { tagParser } from '../../js/modules/utilities.js'
import carteStoreLocator from './carteStoreLocator.png'

export const StoreLocator = ({ title_large, title_small, description, CTA: { label, URL, analytics } }) => {
   const [title, setTitle] = useState(window.innerWidth >= 1200 ? title_large : title_small)
   useEffect(() => {
      window.addEventListener('resize', () => {
         setTitle(window.innerWidth >= 1200 ? title_large : title_small)
      })
   }, [])

   return (
      <div class="container-fluid mt-2 mb-2">
         <div class="store-locator row">
            <div class="text col-12 col-md-5 offset-md-1">
               <div>
                  <h2 class="title no-signature mb-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
                  <p class="lead mb-2">{description}</p>
                  <a
                     href={URL}
                     class="btn btn-primary mb-2 mb-md-0"
                     data-pdb-vi=""
                     data-pdb-zid={analytics.pdbZid}
                     data-pdb-sc={analytics.pdbSc}
                     data-pdb-idc={analytics.pdbIdc}
                     data-oevent-category={analytics.oeventCategory}
                     data-oevent-action={analytics.oeventAction}
                     data-oevent-label={analytics.oeventLabel}
                     data-oevent-other={analytics.oeventOther}
                  >
                     {label}
                  </a>
               </div>
            </div>
            <div class="visuel col-12 col-md-6">
               <img src={carteStoreLocator} alt="" loading="lazy" width="300" height="256" />
            </div>
         </div>
      </div>
   )
}
